import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from 'src/app/models/user.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { UsersStore } from 'src/app/features/users/users-store';
import { RecipientsDisplayComponent } from 'src/app/shared/components/recipients-display/recipients-display.component';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { RecipientsGroup } from 'src/app/models/recipients.model';
import { ContactDisplayComponent } from 'src/app/features/users/components/contact-display/contact-display.component';
import { MiniContactDisplayComponent } from 'src/app/features/users/components/mini-contact-display/mini-contact-display.component';
import { DistributionGroupSquareComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaire-data/components/distribution-group-square/distribution-group-square';

@Component({
    selector: 'que-group-display-recipients',
    imports: [CommonModule, TranslateDirective, TranslatePipe, MiniContactDisplayComponent, RecipientsDisplayComponent, DistributionGroupSquareComponent],
    templateUrl: './group-display-recipients.component.html',
    styleUrls: ['./group-display-recipients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupDisplayRecipientsComponent {
  @Input()
  group?: RecipientsGroup;
  open = false;
  openGroup(event: Event) {
    event.stopPropagation();
    this.open = !this.open;
  }
}
